import { UIIcon } from '../../config/icons';
import { CPlan, cPlanDiscountedPrice, cPlanPromoEffectPrice } from '../mdl/c-plan';
import { PPromo } from '../mdl/p-promo';
import { getCountry } from '../me/me';
import { UIButton } from '../ui/component/button';
import { hLine } from '../ui/component/line';
import { $el } from '../ui/elements';
import { UIClassesSpec } from '../ui/types';
import { $format } from '../y/format';
import { $i18n, yGetI18N, yGetI18Ns, yInterpolate } from '../y/i18n';

export function makePlanCard(classes: UIClassesSpec, button_classes: string, plan: CPlan, promo?: PPromo, on_click?: () => void) {
    const plan_base_price = plan.price[getCountry()];

    let base_price = $format.currency(plan_base_price);
    let discounted_price = $format.currency(cPlanDiscountedPrice(plan, promo));

    const subscription_effect = promo?.effect.find(e => e.kind == 'subscription');

    if(subscription_effect) {
        base_price = $format.currency({ value: plan_base_price.value * subscription_effect.duration_months, currency: plan_base_price.currency });
        discounted_price = $format.currency(cPlanPromoEffectPrice(plan, subscription_effect));
    }

    const subscription_discount_effect = promo?.effect.find(e => e.kind == 'subscription_discount');

    return $el.DIV(['tl-card', classes], $el.DIV('r-card', [
        $el.DIV('r-title', yGetI18N(plan.name)),
        subscription_discount_effect ? [
            base_price != discounted_price && $el.DIV('r-strike', base_price),
            $el.DIV('r-subtitle', yInterpolate(yGetI18N(promo!.texts.card_subtitle), base_price, discounted_price))
        ] : subscription_effect ? [
            base_price != discounted_price && $el.DIV('r-strike', base_price),
            $el.DIV('r-subtitle', yInterpolate(yGetI18N(promo!.texts.card_subtitle), base_price, discounted_price, '' + subscription_effect.duration_months))
        ] : [
            $el.DIV('r-subtitle', base_price)
        ],
        $el.UL(yGetI18Ns(plan.points)),
        new UIButton({ title: $i18n.tl.b_choose_kind + ' ' + yGetI18N(plan.name), on_click: on_click, click_through: !on_click, classes: button_classes }),
        $el.DIV(['r-subscription-image', 'k-' + plan.id]),
        $el.ICON(UIIcon.CHECK, 'r-checkmark')
    ]));
}

export function homeMakeNewPlanCard(classes: UIClassesSpec, button_classes: UIClassesSpec, plan: CPlan, promo?: PPromo, on_click?: () => void) {
    const plan_base_price = plan.price[getCountry()];

    let base_price = $format.currency(plan_base_price);
    let discounted_price = $format.currency(cPlanDiscountedPrice(plan, promo));

    const subscription_effect = promo?.effect.find(e => e.kind == 'subscription');

    if(subscription_effect) {
        base_price = $format.currency({ value: plan_base_price.value * subscription_effect.duration_months, currency: plan_base_price.currency });
        discounted_price = $format.currency(cPlanPromoEffectPrice(plan, subscription_effect));
    }

    const subscription_discount_effect = promo?.effect.find(e => e.kind == 'subscription_discount');

    return $el.DIV(['o-card m-shadow', classes], [
        $el.DIV('r-symbol', [$el.DIV('sym sym-circle-ticket-1'), plan.id == 'plusone' && $el.DIV('sym sym-circle-ticket-1')]),
        $el.DIV('r-title', yGetI18N(plan.name)),
        hLine('m-wide'),
        subscription_discount_effect ? [
            $el.DIV('r-price', yInterpolate(yGetI18N(promo!.texts.card_subtitle), base_price, discounted_price)),
            base_price != discounted_price && $el.DIV('r-original', base_price),
        ] : subscription_effect ? [
            $el.DIV('r-price', yInterpolate(yGetI18N(promo!.texts.card_subtitle), base_price, discounted_price, '' + subscription_effect.duration_months)),
            base_price != discounted_price && $el.DIV('r-original', base_price),
        ] : [
            $el.DIV('r-price', base_price)
        ],
        $el.UL(yGetI18Ns(plan.points)),
        new UIButton({ title: $i18n.tl.b_choose_kind + ' ' + yGetI18N(plan.name), kind: 'k-shadow', on_click: on_click, click_through: !on_click, classes: button_classes }),
        // $el.DIV(['r-subscription-image', 'k-' + plan.id]),
        // $el.ICON(UIIcon.CHECK, 'r-checkmark')
    ]);
}

